import { IconButton } from '@tv2/ui-system/components/IconButton';
import { CloseBasicNext } from '@tv2/ui-system/icons/next/navigation/CloseBasicNext';
import React from 'react';

export default function Toast({ message, onClose }: { message: string; onClose: () => void }) {
  return (
    <div className="flex flex-row bg-light-red p-2 text-white">
      {message}
      <IconButton
        invertIcon
        onClick={onClose}
        icon={CloseBasicNext}
        color="primary-red"
        size="x-small"
      />
    </div>
  );
}
